import React, { ReactNode, useState } from 'react';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';

import { isEmpty } from 'lodash'


interface InstructionResponse {
    name: string
    instructionItems: Array<string>
}

const InstructionIcon = (props: { className: string, id: string, retrieveData: Function, title: string }) => {
    const [popoverOpen, setPopoverOpen] = useState(false);

    const [data, setData] = useState(new Array<InstructionResponse>())

    let timeoutId: NodeJS.Timeout;

    const openPopover = () => {
        timeoutId = setTimeout(() => {
            props.retrieveData().then((d: Array<InstructionResponse>) => {
                setData(d);
                setPopoverOpen(!popoverOpen);
            })
        }, 500);
    }

    const onEnter = () => {
        openPopover();
    }

    const onExit = () => {
        clearTimeout(timeoutId);
        setPopoverOpen(false);
    }

    const popoverBody = () => {
        const items = [] as ReactNode[]
        data.forEach((item: InstructionResponse) => {
            if (!isEmpty(item.instructionItems)) {
                const subitems = [] as ReactNode[];
                item.instructionItems.forEach((subitem) => {
                    subitems.push(<li key={subitem}>{subitem}</li>)
                })

                items.push(
                    <div key={item.name}>
                        <div className="font-weight-bold">{item.name}</div>
                        <ul className="font-weight-normal">
                            {subitems}
                        </ul>
                    </div>
                )
            }
        })
        return items;
    }

    return (
        <span>
            <Popover placement="auto" isOpen={popoverOpen} target={props.id}>
                <PopoverHeader className="text-center">{props.title}</PopoverHeader>
                <PopoverBody>
                    {isEmpty(data) ? '' : popoverBody()}
                </PopoverBody>
            </Popover>
            <span id={props.id} onMouseEnter={onEnter} onMouseLeave={onExit} className={`icon ${props.className}`}></span>

        </span>
    )
}

export default InstructionIcon;
